import styled from 'styled-components';

const CardHeader = styled.div`
  display: flex;
  gap: 8px;
`;

const CardFooter = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Rate = styled.div`
  font-weight: bold;
  text-align: right;
  width: 73px;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
`;

export { CardFooter, CardHeader, Rate, Row };
